import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=2d123ccf&scoped=true&"
import script from "./FieldWrapper.vue?vue&type=script&lang=ts&"
export * from "./FieldWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./FieldWrapper.vue?vue&type=style&index=0&id=2d123ccf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d123ccf",
  null
  
)

export default component.exports